export const populateOrderData = (data) => {
  let additionalInfoWithLineItems = [];

  for (let i = 0; i < data?.grandAdditionalInfo?.length; i++) {
    const a = data?.grandAdditionalInfo[i];
    const productName = data?.grandAdditionalInfo[i][0].split('Item: ')[1];
    const color = data?.grandAdditionalInfo[i][1].split('Item Color: ')[1];
    const placements = data?.grandAdditionalInfo[i]?.filter((g) =>
      g?.startsWith('Placement')
    );

    const printType = data?.grandAdditionalInfo[i]
      ?.find((g) => g?.startsWith('Decoration Method'))
      .split('Decoration Method: ')[1];

    let lineItems = data?.lineItems?.filter(
      (l) => l?.product?.includes(productName) && l?.color === color
    );

    lineItems = lineItems?.length > 0 ? lineItems : data?.lineItems;

    if (lineItems?.length > 0) {
      for (let j = 0; j < lineItems.length; j++) {
        if (!lineItems[j].printType) lineItems[j].printType = printType;
        if (lineItems[j].printAreas) continue;

        if (placements?.length > 0) {
          for (let k = 0; k < placements.length; k++) {
            const placement = placements[k].split('Placement: ')[1];
            const isExist = lineItems[j].printAreas?.find(
              (e) => e.printAreaName === placement && e?.artworkUrl
            );

            let rightChestValue = '';

            if (placement === 'LEFT CHEST') {
              const a1 = a?.find((a) => a?.includes('TEXT LINE 1'));
              if (!!a1) {
                rightChestValue += `${a1?.split(':')[1]}%250A`;
              }
              const a2 = a?.find((a) => a?.includes('TEXT LINE 2'));
              if (!!a2) {
                rightChestValue += `${a2?.split(':')[1]}%250A`;
              }
              const a3 = a?.find((a) => a?.includes('TEXT LINE 3'));
              if (!!a3) {
                rightChestValue += `${a3?.split(':')[1]}`;
              }
            }

            const artworkUrl =
              placement === 'RIGHT CHEST'
                ? 'https://images.shirtly.com/raw/upload/v1663332917/BOTApp/StaplesPO/PartnBrigham/ArtFile/HarvardMedMGH_tmq0zh.dst'
                : placement === 'LEFT CHEST'
                ? `https://images.shirtly.com/image/upload/l_text:Roboto_51_bold:${rightChestValue},co_rgb:FFFFFF/e_trim/v1663335494/BOTApp/StaplesPO/PartnBrigham/5X5_vgx54x.png`
                : '';

            if (!isExist) {
              if (!lineItems[j].printAreas) {
                lineItems[j].printAreas = [
                  {
                    printAreaName: placement,
                    artworkUrl,
                  },
                ];
              } else {
                lineItems[j].printAreas.push({
                  printAreaName: placement,
                  artworkUrl,
                });
              }
            }
          }
        } else {
          lineItems[j].printAreas = [
            {
              printAreaName: '',
              artworkUrl: '',
            },
          ];
        }
      }
    } else {
      lineItems.printAreas = [
        {
          printAreaName: '',
          artworkUrl: '',
        },
      ];

      lineItems.printType = printType;
    }

    additionalInfoWithLineItems.push({
      additionalInfo: a,
      lineItems,
    });
  }

  return { data, additionalInfoWithLineItems };
};
